let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2w7Ku")).then(() => parcelRequire('5pz6a'));